/* Progressive enhancement: the native forms and details work without JS. */
(() => {
  const close = (details, focus) => {
    details.open = false;
    if (focus) details.querySelector('summary').focus();
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-localization][open]').forEach(details => {
      if (!details.contains(event.target)) close(details);
    });
    const x = event.target.closest('[data-localization-close]');
    if (x) close(x.closest('[data-localization]'), true);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('[data-localization][open]');
    if (!details) return;
    event.stopPropagation();
    close(details, true);
  }, true);
  // Opening one control closes the others; the current country scrolls into view.
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches || !details.matches('[data-localization]') || !details.open) return;
    document.querySelectorAll('[data-localization][open]').forEach(d => { if (d !== details) d.open = false; });
    const on = details.querySelector('.localization__country.is-on');
    if (on) on.scrollIntoView({block: 'nearest'});
  }, true);
  // Country search filters the list.
  document.addEventListener('input', event => {
    const box = event.target.closest('[data-localization-search]');
    if (!box) return;
    const q = box.value.trim().toLowerCase();
    box.closest('form').querySelectorAll('.localization__list li').forEach(li => {
      li.hidden = q !== '' && !li.dataset.name.includes(q);
    });
  });
  // Enter in the search box picks the first match instead of submitting nothing.
  document.addEventListener('keydown', event => {
    const box = event.target.closest && event.target.closest('[data-localization-search]');
    if (!box || event.key !== 'Enter') return;
    event.preventDefault();
    const first = box.closest('form').querySelector('.localization__list li:not([hidden]) button');
    if (first) first.click();
  });
})();
